import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconCheckProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconCheckSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconCheckSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M6.16668 12.22L2.58002 8.6267L3.75335 7.4467L6.16668 9.86003L12.2467 3.78003L13.42 4.96003L6.16668 12.22Z" />
    </svg>
  );
}

function OutlineSvg({ className, title }: IconCheckSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M6.16669 11.9533L2.75336 8.5333L3.58002 7.7133L6.16669 10.3L12.42 4.04663L13.2467 4.8733L6.16669 11.9533Z" />
    </svg>
  );
}

export default function IconCheck({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconCheckProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
